// extracted by mini-css-extract-plugin
export default {"close-button__content":"closeButton_close-button__content__zUAzw"};